import {Injectable} from '@angular/core';
import {ShiftService, Balance} from '../../generated/sales-terminal-client';
import {SnackService} from '../snack/snack.service';
import {PriceInCentsPipe} from '../../pipes/priceInCents/priceInCents.pipe';
import {tap} from 'rxjs';

@Injectable()
export class CashService {
  public balance: Balance = null;

  constructor(private shiftService: ShiftService,
              private snackService: SnackService,
              private priceInCentsPipe: PriceInCentsPipe) {
  }

  public updateBalance(): void {
    this.shiftService.shiftBalanceGet().pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    ).subscribe((balance) => this.balance = balance);
  }

  public cashIn(amount: number): void {
    this.shiftService.shiftInsertcashPost({amount: this.priceInCentsPipe.transform(amount)}).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    ).subscribe((balance) => this.balance = balance);
  }
  public cashOut(amount: number): void {
    this.shiftService.shiftWithdrawcashPost({amount: this.priceInCentsPipe.transform(amount)}).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    ).subscribe((balance) => this.balance = balance);
  }
}
